import React from "react";
import PropTypes from "prop-types";

const CaretLargeRight = () => (
	<svg width="29" height="54" viewBox="0 0 29 54">
		<path fill="#231F20" fillRule="evenodd" d="M3.52645365,1.44016329 L29.6631775,27.9997443 L29.6631775,27.9997443 L3.53830124,54.5859466 C2.96061389,55.1738351 2.01572802,55.1821047 1.42783958,54.6044173 C1.42336768,54.600023 1.41892352,54.5956006 1.41450735,54.5911503 C0.824594155,53.9966755 0.822722111,53.0382478 1.41030851,52.441473 L25.4754639,28 L25.4754639,28 L1.3974374,3.53459728 C0.819060612,2.94691535 0.826603919,2.00163799 1.41428585,1.42326121 C1.41435967,1.42318855 1.41443351,1.4231159 1.41450735,1.42304325 C2.00246021,0.844640695 2.94795484,0.852305144 3.52645365,1.44016329 Z" transform="translate(-1 -1)"/>
	</svg>
);

export default CaretLargeRight;
